<div class="space-y-4">
    <div
        *ngFor="let item of skeletonItems"
        class="bg-[#FFFFFF] border border-[#E5E8EC] rounded-[16px] p-4 animate-pulse"
    >
        <div class="flex gap-4">
            <div
                class="w-[80px] h-[80px] bg-gray-200 rounded-lg flex-shrink-0"
            ></div>

            <div class="flex-grow">
                <div class="flex flex-col md:flex-row md:justify-between gap-2">
                    <div class="flex-grow">
                        <div class="h-5 bg-gray-200 rounded w-3/4 mb-2"></div>
                        <div class="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
                        <div class="h-4 bg-gray-200 rounded w-1/3"></div>
                    </div>

                    <div class="hidden md:flex items-start gap-6">
                        <div class="text-center">
                            <div
                                class="h-3 bg-gray-200 rounded w-12 mb-2"
                            ></div>
                            <div class="h-4 bg-gray-200 rounded w-8"></div>
                        </div>
                        <div class="text-center">
                            <div
                                class="h-3 bg-gray-200 rounded w-16 mb-2"
                            ></div>
                            <div class="h-4 bg-gray-200 rounded w-14"></div>
                        </div>
                        <div class="text-center">
                            <div
                                class="h-3 bg-gray-200 rounded w-24 mb-2"
                            ></div>
                            <div class="h-4 bg-gray-200 rounded w-12"></div>
                        </div>
                        <div class="text-center">
                            <div
                                class="h-3 bg-gray-200 rounded w-20 mb-2"
                            ></div>
                            <div class="h-4 bg-gray-200 rounded w-20"></div>
                        </div>
                        <div class="flex items-center gap-2">
                            <div
                                class="h-9 bg-gray-200 rounded-lg w-[120px]"
                            ></div>
                            <div
                                class="h-9 w-9 bg-gray-200 rounded-lg"
                            ></div>
                        </div>
                    </div>
                </div>

                <div class="md:hidden mt-4">
                    <div class="grid grid-cols-2 gap-3">
                        <div>
                            <div
                                class="h-3 bg-gray-200 rounded w-16 mb-1"
                            ></div>
                            <div class="h-4 bg-gray-200 rounded w-10"></div>
                        </div>
                        <div>
                            <div
                                class="h-3 bg-gray-200 rounded w-20 mb-1"
                            ></div>
                            <div class="h-4 bg-gray-200 rounded w-16"></div>
                        </div>
                        <div>
                            <div
                                class="h-3 bg-gray-200 rounded w-12 mb-1"
                            ></div>
                            <div class="h-4 bg-gray-200 rounded w-14"></div>
                        </div>
                        <div>
                            <div
                                class="h-3 bg-gray-200 rounded w-24 mb-1"
                            ></div>
                            <div class="h-4 bg-gray-200 rounded w-20"></div>
                        </div>
                    </div>
                    <div
                        class="flex justify-end items-center gap-2 mt-4 pt-3 border-t border-gray-100"
                    >
                        <div class="h-8 bg-gray-200 rounded-lg w-[100px]"></div>
                        <div class="h-8 w-8 bg-gray-200 rounded-lg"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-end mt-3">
            <div class="h-4 bg-gray-200 rounded w-32"></div>
        </div>
    </div>
</div>

